import { IBaseComponentProps } from '@actr/specs/src/base-component-props';
import { ButtonSizes, ButtonTypes } from '@actr/ui/src/components/_atoms/button/specs';
import { Text } from '@actr/ui/src/components/_atoms/text';
import classNames from 'classnames';
import React, { FC, memo, useMemo } from 'react';

import * as Styled from './style.css';

export interface ButtonProps extends IBaseComponentProps {
  /** Цветовая схема кнопки
   * @default ButtonTypes.BRAND
   */
  buttonType?: ButtonTypes;
  /** Размер кнопки
   * @default ButtonSizes.M
   */
  size?: ButtonSizes;
  /** Альтернативная (инвертированная) цветовая схема кнопки */
  inverted?: boolean;
  /** url для перехода */
  url: string;
}

/**
 * семмантически корректная кнопка для SEO через <a>
 * */
const SeoButton: FC<ButtonProps> = props => {
  const {
    className,
    buttonType = ButtonTypes.BRAND,
    size = ButtonSizes.S,
    inverted = false,
    children,
    url
  } = props;

  const themeFontName = useMemo(() => {
    switch (size) {
      case ButtonSizes.L:
      case ButtonSizes.M: return 'paragraph.m.semi';
      default: return 'paragraph.s.semi';
    }
  }, [size]);

  return (
    <a
      href={url}
      className={classNames(Styled.SeoButton({
        buttonType,
        size,
        inverted,
      }), className)}>
      {
          children && (
            <Text className={Styled.SeoButtonText} font={themeFontName}>
              {children}
            </Text>
          )
        }
    </a>
  );
};

export default memo(SeoButton);
